import { render, staticRenderFns } from "./messageLeaveDouble.vue?vue&type=template&id=bc2436e8&scoped=true"
import script from "./messageLeaveDouble.vue?vue&type=script&lang=js"
export * from "./messageLeaveDouble.vue?vue&type=script&lang=js"
import style0 from "./messageLeaveDouble.vue?vue&type=style&index=0&id=bc2436e8&prod&lang=stylus&scoped=true"
import style1 from "./messageLeaveDouble.vue?vue&type=style&index=1&id=bc2436e8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2436e8",
  null
  
)

export default component.exports